<style lang="scss" scoped>
.user {
  float: left;
  width: 120px;
  line-height: 30px;
  color: #282729;
  text-align: center;
  margin: 0 14px;
  position: relative;
  font-size: 12px;
  font-weight: 400;
  &::after {
    content: '或';
    position: absolute;
    right: -20px;
    top: 45px;
  }
  &:last-child {
    &::after {
      content: '';
    }
  }
  .name {
    line-height: 42px;
  }
  .context {
    border-bottom: 1px solid #EAEBF0;
    position: relative;
    .x {
      position: absolute;
      top: -6px;
      right: -17px;
      color: #FF3973;
      cursor: pointer;
      background: #fff;
    }
  }
  .list_ctn {
    border: 1px solid #FF3973;
    padding: 0 10px;
    &.blank {
      border: 1px dashed #E9E9E9;
    }
  }
  .add {
    color: #999;
    cursor: pointer;
  }
}
.title_help_pop {
  font-size: 12px;
  div {
    font-weight: bold;
  }
  p {
    color: #666;
    line-height: 30px;
  }
}
</style>
<style lang="scss">
.profile_label_list {
  margin-left: 20px!important;
  .title {
    line-height: 50px;
    text-align: center;
    font-weight: bold;
    border-bottom: 1px solid #E9E9E9;
    margin: -12px -12px 15px;
  }
  .label_ctn {
    line-height: 30px;
    .fl {
      width: 70px;
      text-align: center;
    }
    .fr {
      width: calc(100% - 70px);
      span {
        text-align: center;
        display: inline-block;
        padding: 0 10px;
        margin: 0 5px 15px;
        background: #F5F5F5;
        border: 1px solid #F5F5F5;
        border-radius: 2px;
        cursor: pointer;
        position: relative;
        font-size: 12px;
        user-select: none;
        &.check {
          border: 1px solid #FF3973;
          .x {
            display: block;
          }
        }
        .x {
          display: none;
          position: absolute;
          top: -5px;
          right: -5px;
          color: #FF3973;
          background: #fff;
        }
      }
    }
    .clear {
      clear: both;
    }
  }
}
</style>

<template>
  <!-- 须加上@click.stop 防止冒泡 -->
  <div style="width: 740px;" @click.stop>
    <div class="user" v-for="useObj in users" :key="useObj.name">
      <div class="name">{{ useObj.name }}</div>
      <div class="list_ctn" :class="{ 'blank': !useObj.list || useObj.list.length == 0 }">
        <div class="context" v-for="obj in useObj.list" :key="obj.name">
          {{ obj.name }}
          <i class="el-icon-circle-close x" @click="delUserObj(useObj.list, obj, useObj.profiles)"></i>
        </div>
        <!-- v-model="useObj.show" 外部控制数据show为false来隐藏弹窗 -->
        <el-popover
          trigger="click" placement="right" v-model="useObj.show"
          popper-class="profile_label_list" style="padding: 0;height: 330px;">
          <div slot="reference" class="add" @click="addClick(useObj)">点击添加标签</div>
          <div class="title">标签种类
            <div class="fr" style="margin-right: 10px;">
              <el-popover trigger="hover" placement="bottom-end">
                <i class="el-icon-question" slot="reference" style="cursor: pointer;"></i>
                <div>
                  <div class="title_help_pop">
                    <div>温馨提示</div>
                    <p>手提物：人物手中拎着塑料袋</p>
                  </div>
                </div>
              </el-popover>

            </div>
          </div>
          <div class="label_ctn" v-for="{ name, labels } in useObj.profiles" :key="name">
            <div class="fl">{{ name }}</div>
            <div class="fr">
              <!-- @click="toggleClick(item, useObj.list, labels, useObj.profiles)"> -->
              <span v-for="item in labels" :key="item.value" :class="{ 'check': item.check }"
                @click="toggleClick(item, useObj, labels)">
                {{ item.name }}
                <i class="el-icon-circle-close x"></i>
              </span>
            </div>
            <div class="clear"></div>
          </div>
        </el-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserProfileObjs',
  props: {
    value: Array
  },
  data () {
    return {
      users: [],
      initUsers: [] // 深拷贝users物体列表原始数据，供取消操作还原使用
    }
  },
  computed: {
    labelListMap () {
      return this.$store.state.label.codeMap
    }
  },
  watch: {
    value: {
      immediate: true,
      handler (v) { // 取消展开之后 选中确定的数据状态
        this.handleValueChange(v)
      }
    },
    labelListMap: {
      immediate: true,
      handler (v) {
        // 初始化 initUsers 数据  如果已经初始化过就不再执行
        if (this.initUsers.length > 0) return
        this.initBlankList() // 初始化空物体模板列表
        // 当组件销毁时 再次点击会重新初始化原始列表数据，会置空当前展示内容
        // 再次执行 handleValueChange 更新为外部传入的 value 数据
        this.handleValueChange(this.value)
      }
    }
  },
  methods: {
    addClick (data) { // 点击添加时 关闭其他弹窗
      this.users.forEach(el => {
        if (el.name != data.name && el.show) el.show = false
      })
    },
    // 外部父级可能存在 @click.stop 导致点击父级空白区 这里的弹窗关闭不了
    // 供父级调用 关闭弹窗
    closePopovers () {
      this.users.forEach(el => {
        if (el.show) el.show = false
      })
    },
    getInitProfileListStr () {
      let sortMap = this.$store.state.label.sortMap
      let sortList = type => sortMap && sortMap[type] ? this.labelListInit(sortMap[type]) : []
      let list = [
        { name: '性别', labels: sortList('SEX'), type: 'SEX' },
        { name: '年龄', labels: sortList('AGE'), type: 'AGE' },
        { name: '衣着', labels: sortList('CLOTHING'), type: 'CLOTHING' },
        { name: '职业', labels: sortList('PEOPLE_TYPE'), type: 'PEOPLE_TYPE' },
        { name: '头部', labels: sortList('HEAD'), type: 'HEAD' },
        { name: '脸部', labels: sortList('FACE'), type: 'FACE' },
        { name: '特殊', labels: sortList('SPECIAL'), type: 'SPECIAL' },
        { name: '行为', labels: sortList('BEHAVIOUR'), type: 'BEHAVIOUR' }
      ]
      // 深拷贝各个数据以防之间互相物体 profiles 之间的影响, 数据虽然相同，但是用同一份数据 会导致 check 状态联动
      // 也可以 popper 的 show 事件中增加对每个物体选择的属性列表对应的数据check状态 重置到统一弹窗中
      return JSON.stringify(list)
    },
    initBlankList () {
      let listJsonStr = this.getInitProfileListStr()
      this.initUsers = [ // 初始化空模板物体列表  方便取消操作时数据回到初始状态
        { name: '画像A', list: [], profiles: JSON.parse(listJsonStr), show: false }, { name: '画像B', list: [], profiles: JSON.parse(listJsonStr), show: false },
        { name: '画像C', list: [], profiles: JSON.parse(listJsonStr), show: false }, { name: '画像D', list: [], profiles: JSON.parse(listJsonStr), show: false },
        { name: '画像E', list: [], profiles: JSON.parse(listJsonStr), show: false }
      ]
      this.users = JSON.parse(JSON.stringify(this.initUsers)) // 深拷贝赋值展示数据交互
    },
    handleValueChange (v) {
      v = v || this.value
      let blankList = JSON.parse(JSON.stringify(this.initUsers))
      if (v && v.length) {
        let profilesStr = this.getInitProfileListStr()
        let data = JSON.parse(JSON.stringify(v)).map(el => { // 填充 profiles 数据 以及 各个标签的check状态
          let checkCodes = el.list.map(el => el.code)
          let ps = JSON.parse(profilesStr)
          ps.forEach(ele => {
            ele.labels.forEach(label => {
              label.check = checkCodes.indexOf(label.code) > -1 ? true : false
            })
          })
          el.profiles = ps
          return el
        })
        if (data.length < 5) {
          let len = data.length
          data.splice(len, 0, ...blankList.slice(len))
        }
        this.users = data
      } else {
        this.users = blankList // 当prop value 数据为空数组时 还原当前展示列表users为初始模板数据 initUsers 深拷贝防止数据污染
      }
    },
    labelListInit (arr) {
      return JSON.parse(JSON.stringify(arr)).map(el => {
        this.$set(el, 'check', false)
        return el
      })
    },
    toggleClick (item, userObj, labelList) { // 当前点击的标签 当前物体的已选label列表 当前点击的标签所属于的label列表  当前物体的弹窗变迁列表
      item.check = !item.check

      let statu = item.check // 缓存下 下面重置所有可能会影响掉
      // 只能选一个情况 这里先去除掉userObjList当前同类 group 所选择过的内容（如果存在的话）,labelList中check都重置为false
      // 如果需要可以选择多个，此处可注释
      let curCodeIdx = this.delCodeItemInArr(userObj.list, item, 'group')
      labelList.forEach(el => { if (el.check) el.check = false })
      item.check = statu

      // 点击顺序展示
      // let userObjList = userObj.list, profiles = userObj.profiles
      // if (item.check) {
      //   if (curCodeIdx > -1) userObjList.splice(curCodeIdx, 0, item) // 如果存在同类的 插入到同类数据的位置
      //   else userObjList.push(item)
      // } else {
      //   this.delUserObj(userObjList, item, profiles)
      // }

      // 标签顺序展示
      userObj.list = userObj.profiles.reduce((res, cur) => {
        let checks = cur.labels.filter(el => el.check)
        return res.concat(checks.length ? checks : [])
      }, [])

      this.upDataParam()
    },
    delCodeItemInArr (arr, item, key) { // 删除列表中 key 值是 item.key 的内容项
      let idx = arr.map(el => el[key]).indexOf(item[key])
      if (idx > -1) arr.splice(idx, 1)
      return idx // 返回索引供外部使用
    },
    delUserObj (userObjList, item, profiles) { // 当前物体的已选label列表  当前删除的标签code 当前物体对应的弹窗标签列表  当前删除的标签context
      // 数据中删除此项
      // userObjList.splice(list.map(el => el.context).indexOf(context), 1) // 如果同一类可多选的需求下  可以根据 context 来删除处理
      this.delCodeItemInArr(userObjList, item, 'group')
      // 更新当前物体对应弹窗数据的勾选状态
      profiles.filter(el => el.type == item.group).forEach(element => {
        element.labels.forEach(ele => {
          if (ele.check) ele.check = false // 删除之后取消
        })
      });
      this.upDataParam()
    },
    upDataParam () { // 更新数据
      this.$emit('input', this.users)
    }
  }
}
</script>
